import { FC } from "react";
import cx from "classnames";
import Paper from "@mui/material/Paper";
import Backdrop from "@mui/material/Backdrop";
import Button from "@/components/Button";
import styles from "./MobilePopup.module.scss";

type Action = {
  onClick: () => void;
  type: string;
  label: string;
  isLoading?: boolean;
};

type Props = {
  actions?: Array<Action>;
  onClose: () => void;
  closeOnSelect?: boolean;
};

const MobilePopup: FC<Props> = ({ actions, onClose, children }) => {
  return (
    <Backdrop open className={styles.backdrop} onClick={onClose}>
      <Paper
        className={styles.paper}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={cx(styles.root, {
            [styles.actionRoot]: actions && actions.length > 0,
          })}
        >
          <span className={styles.closeIndicator} onClick={onClose} />
          {children}
          {actions && actions?.length > 0 && (
            <div className={styles.actionsContainer}>
              {actions.map(({ label, onClick, type, isLoading }) => (
                <Button
                  key={label}
                  onClick={onClick}
                  variant={type === "primary" ? "contained" : "outlined"}
                  color={type === "primary" ? "primary" : "info"}
                  className={styles.button}
                  disabled={isLoading}
                >
                  {label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </Paper>
    </Backdrop>
  );
};

export default MobilePopup;
